import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginService } from "../../services/Login.service";

interface LoginPageProps {
  onLogin: (token: string, role: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const authResponse = await LoginService.authenticateUser(mail, password);
      const { token, role } = authResponse;

      onLogin(token, role);

      navigate(role === "admin" ? "/admin" : "/products");
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = () => {
    navigate("/register"); // Navegar a la página de registro
  };

  return (
    <div style={styles.container}>
      <div style={styles.formContainer}>
        <h1 style={styles.title}>Bienvenido</h1>
        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Mail:</label>
            <input
              type="text"
              value={mail}
              onChange={(e) => setMail(e.target.value)}
              style={styles.input}
            />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Contraseña:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />
          </div>
          <button type="submit" disabled={loading} style={styles.buttonPrimary}>
            {loading ? "Iniciando sesión..." : "Iniciar Sesión"}
          </button>
        </form>
        {error && <p style={styles.error}>{error}</p>}
        <button onClick={handleRegister} style={styles.buttonSecondary}>
          Registrarse
        </button>
        <button
          onClick={() => navigate("/user/password/forgot")}
          style={{
            marginTop: "0.5rem",
            background: "none",
            border: "none",
            color: "#007bff",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          ¿Olvidaste tu contraseña?
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
  },
  formContainer: {
    padding: "2rem",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center" as const,
  },
  title: {
    marginBottom: "1rem",
    fontSize: "24px",
    fontWeight: "bold",
  },
  form: {
    marginBottom: "1rem",
  },
  inputGroup: {
    marginBottom: "1rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    fontSize: "14px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "0.5rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  buttonPrimary: {
    width: "100%",
    padding: "0.5rem",
    borderRadius: "4px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "bold",
  },
  buttonSecondary: {
    width: "100%",
    padding: "0.5rem",
    borderRadius: "4px",
    backgroundColor: "#6c757d",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    marginTop: "0.5rem",
    fontWeight: "bold",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginTop: "1rem",
  },
};

export default LoginPage;
